import { ReportColumnConfig } from 'components/ReportGrid_New/types';

export const B2B_REST_MESSAGES = 'B2B Rest Queue Messages';
export const B2B_REST_MESSAGES_INFO_MESSAGE =
  'Displays the B2B Rest Queue Messages for the date range provided';
export const REPORT_TITLE = 'b2bRestQueueMessages';

export const columns: ReportColumnConfig[] = [
  { name: 'queue', title: 'Queue' },
  { name: 'queueMessageId', title: 'Queue Message Id' },
  { name: 'messageGuid', title: 'Message Guid', width: '150' },
  { name: 'messageType', title: 'Message Type' },
  { name: 'messageContent', title: 'Message Content', width: '200' },
  { name: 'messageHash', title: 'Message Hash', width: '150' },
  { name: 'sender', title: 'Sender' },
  { name: 'senderReference', title: 'Sender Reference' },
  { name: 'recipient', title: 'Recipient' },
  { name: 'repairerSiteCode', title: 'Repairer Site Code' },
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'entryDate', title: 'Entry Date', type: 'date' },
  { name: 'readDate', title: 'Read Date', type: 'date' },
];